import p from "../button/button.js";
import { DtIconMoreVertical as u } from "@dialpad/dialtone-icons/vue3";
import { resolveComponent as r, createBlock as i, openBlock as s, mergeProps as l, withCtx as o, renderSlot as m, createVNode as c } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const _ = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeSettingsMenuButton",
  components: {
    DtButton: p,
    DtIconMoreVertical: u
  },
  inheritAttrs: !1,
  props: {
    /**
     * Determines whether the button should display the update state
     * default is false
     * @values true, false
     */
    updateAvailable: {
      type: Boolean,
      default: !1
    },
    /**
     * Aria label
     */
    ariaLabel: {
      type: String,
      required: !0
    }
  }
};
function f(e, b, t, g, v, k) {
  const a = r("dt-icon-more-vertical"), n = r("dt-button");
  return t.updateAvailable ? (s(), i(n, l({
    key: 0,
    importance: "outlined",
    size: "xs",
    "icon-position": "right",
    class: "d-recipe-settings-menu-button-update",
    "aria-label": t.ariaLabel
  }, e.$attrs), {
    icon: o(() => [
      c(a, { size: "300" })
    ]),
    default: o(() => [
      m(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["aria-label"])) : (s(), i(n, l({
    key: 1,
    importance: "clear",
    kind: "inverted",
    class: "d-recipe-settings-menu-button",
    "aria-label": t.ariaLabel
  }, e.$attrs), {
    icon: o(() => [
      c(a, { size: "300" })
    ]),
    _: 1
  }, 16, ["aria-label"]));
}
const $ = /* @__PURE__ */ d(_, [["render", f]]);
export {
  $ as default
};
//# sourceMappingURL=settings-menu-button.js.map
